import BackofficeResiliationRequestsBase from './BackofficeResiliationRequestsBase';

export default class BackofficeResiliationRequestsHistory extends BackofficeResiliationRequestsBase {
  constructor() {
    super('history-table', 5);
  }

  onDataChanged(data) {
    // Logic spécifique à l'historique des résiliations
  }
}